import React, { useState } from 'react';
import { 
  GlobeAltIcon,
  MapPinIcon,
  CalendarIcon,
  BuildingOfficeIcon,
  UserIcon
} from '@heroicons/react/24/outline';
import { useNavigate } from 'react-router-dom';

interface IPAddressDetails {
  ipAddress: string;
  location: string;
  description: string;
  department: string;
  requestedBy: string;
  expiryDate: string;
}

export const AddIPAddressPage: React.FC = () => {
  const navigate = useNavigate();
  const [ipDetails, setIpDetails] = useState<IPAddressDetails>({
    ipAddress: '',
    location: '',
    description: '',
    department: '',
    requestedBy: '',
    expiryDate: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Add your submission logic here
    navigate('/superadmin/security'); // Navigate back to security page after submission
  };

  return (
    <div className="p-6">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center mb-6">
          <GlobeAltIcon className="w-8 h-8 text-[#FF5722] mr-3" />
          <h1 className="text-2xl font-bold text-gray-900">Add IP Address to Whitelist</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {/* IP Address Input */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <div className="space-y-4">
              <div className="p-4 bg-gray-50 rounded-lg">
                <label className="block">
                  <span className="text-gray-700 font-medium">IP Address</span>
                  <input
                    type="text"
                    value={ipDetails.ipAddress}
                    onChange={(e) => setIpDetails({...ipDetails, ipAddress: e.target.value})}
                    placeholder="e.g., 192.168.1.1"
                    className="mt-1 block w-full border rounded-md p-2"
                    required
                  />
                </label>
              </div>

              <div className="p-4 bg-gray-50 rounded-lg">
                <label className="block">
                  <span className="text-gray-700 font-medium">Location</span>
                  <div className="mt-1 flex items-center">
                    <MapPinIcon className="w-5 h-5 text-gray-400 mr-2" />
                    <input
                      type="text"
                      value={ipDetails.location}
                      onChange={(e) => setIpDetails({...ipDetails, location: e.target.value})}
                      placeholder="e.g., Head Office - New York"
                      className="block w-full border rounded-md p-2"
                      required
                    />
                  </div>
                </label>
              </div>

              <div className="p-4 bg-gray-50 rounded-lg">
                <label className="block">
                  <span className="text-gray-700 font-medium">Description</span>
                  <textarea
                    value={ipDetails.description}
                    onChange={(e) => setIpDetails({...ipDetails, description: e.target.value})}
                    placeholder="Purpose of whitelisting this IP"
                    className="mt-1 block w-full border rounded-md p-2"
                    rows={3}
                    required
                  />
                </label>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <label className="block">
                    <span className="text-gray-700 font-medium">Department</span>
                    <div className="mt-1 flex items-center">
                      <BuildingOfficeIcon className="w-5 h-5 text-gray-400 mr-2" />
                      <input
                        type="text"
                        value={ipDetails.department}
                        onChange={(e) => setIpDetails({...ipDetails, department: e.target.value})}
                        placeholder="e.g., IT Department"
                        className="block w-full border rounded-md p-2"
                        required
                      />
                    </div>
                  </label>
                </div>

                <div className="p-4 bg-gray-50 rounded-lg">
                  <label className="block">
                    <span className="text-gray-700 font-medium">Requested By</span>
                    <div className="mt-1 flex items-center">
                      <UserIcon className="w-5 h-5 text-gray-400 mr-2" />
                      <input
                        type="text"
                        value={ipDetails.requestedBy}
                        onChange={(e) => setIpDetails({...ipDetails, requestedBy: e.target.value})}
                        placeholder="Full Name"
                        className="block w-full border rounded-md p-2"
                        required
                      />
                    </div>
                  </label>
                </div>
              </div>

              <div className="p-4 bg-gray-50 rounded-lg">
                <label className="block">
                  <span className="text-gray-700 font-medium">Expiry Date</span>
                  <div className="mt-1 flex items-center">
                    <CalendarIcon className="w-5 h-5 text-gray-400 mr-2" />
                    <input
                      type="date"
                      value={ipDetails.expiryDate}
                      onChange={(e) => setIpDetails({...ipDetails, expiryDate: e.target.value})}
                      className="block w-full border rounded-md p-2"
                      required
                    />
                  </div>
                </label>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end space-x-4">
            <button
              type="button"
              onClick={() => navigate('/superadmin/security')}
              className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => {/* Add your block IP logic here */}}
              className="bg-[#FF5722] text-white px-6 py-2 rounded-md hover:bg-[#F4511E]"
            >
              Add Block IP Address
            </button>
            <button
              type="submit"
              className="bg-[#FF5722] text-white px-6 py-2 rounded-md hover:bg-[#F4511E]"
            >
              Add Whitelist IP Address
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddIPAddressPage; 